module.exports = __webpack_public_path__ + "img/home-app-image.77c8cdcc.png";